import { api } from "@convex/_generated/api";
import { Button, Card, ChatIcon, IconTile, Kbd, PlusIcon } from "@buddy/ui";
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { newChatKeys } from "@/app/shortcuts";
import { useUi } from "@/app/ui-state";
import { useOrg } from "@/lib/org";

export const Route = createFileRoute("/_app/_main/chat/")({ component: Page });

// /chat opens the most recent chat. With none yet, it offers to start one.
function Page() {
  const org = useOrg();
  const { openNewChat } = useUi();
  const rooms = useQuery(api.rooms.listForSidebar, { orgId: org.id });
  if (rooms === undefined) return <Card className="flex-1" aria-busy />;
  const latest = rooms.find((room) => room.kind !== "backchannel");
  if (latest !== undefined) return <Navigate to="/chat/$roomId" params={{ roomId: latest._id }} replace />;
  return (
    <Card className="flex-1 items-center justify-center gap-5">
      <IconTile tone="flat" size="xl">
        <ChatIcon />
      </IconTile>
      <div className="flex flex-col items-center gap-1.5 text-center">
        <p className="text-[20px] font-medium leading-6 tracking-title text-text">No chats yet</p>
        <p className="max-w-[44ch] text-[13px] leading-[18px] tracking-normal text-text-2">
          Open a dm with one employee, or pick a few to make a room. They wake when someone mentions them.
        </p>
      </div>
      <Button variant="primary" onClick={openNewChat}>
        <PlusIcon />
        New chat
        <span className="ml-1 flex gap-[3px]">
          {newChatKeys().map((key) => (
            <Kbd key={key} onAccent>
              {key}
            </Kbd>
          ))}
        </span>
      </Button>
    </Card>
  );
}
